import { render, staticRenderFns } from "./MainFooterV2.vue?vue&type=template&id=015d7109&scoped=true&"
import script from "./MainFooterV2.vue?vue&type=script&lang=js&"
export * from "./MainFooterV2.vue?vue&type=script&lang=js&"
import style0 from "./MainFooterV2.vue?vue&type=style&index=0&id=015d7109&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d7109",
  null
  
)

export default component.exports